/* session/actions */
import { action } from "typesafe-actions";
import { Session, SessionActionTypes } from "./types";

export const fetchRequest = (
  callback?: (error: string | null, data: Session | null) => unknown
) => action(SessionActionTypes.FETCH, {  callback });

export const fetchSecondRequest = (
  callback?: (error: string | null, data: Session | null) => unknown
) => action(SessionActionTypes.SECOND_FETCH, { callback });

export const fetchSuccess = (data: Session) =>
  action(SessionActionTypes.FETCH_SUCCESS, data);

export const fetchSecondSuccess = (data: Session) =>
  action(SessionActionTypes.SECOND_FETCH_SUCCESS, data);

export const fetchError = (error: string) =>
  action(SessionActionTypes.FETCH_ERROR, error);

export const setSession = (data: Session) =>
  action(SessionActionTypes.SET_SESSION, data);

export const dirty = () => action(SessionActionTypes.DIRTY);
export const clearStorage = () => action(SessionActionTypes.CLEAR_STORAGE);
export const unDirty = () => action(SessionActionTypes.UN_DIRTY);

export const logoutRequest = (
  callback?: (error: string | null, success: boolean) => unknown
) => action(SessionActionTypes.LOGOUT_REQUEST, { callback });

export const logoutSuccess = () => action(SessionActionTypes.LOGOUT_SUCCESS);

export const logoutError = (error: string) =>
  action(SessionActionTypes.LOGOUT_ERROR, error);
